import type { RecordBase, SourceRef } from './model';

export const exportKinds = [
  'campaign',
  'content',
  'proposal',
  'publication',
  'business_event',
  'manual_metric_reading',
] as const;
export type ExportKind = (typeof exportKinds)[number];
export const exportKindLabels: Record<ExportKind, string> = {
  campaign: 'Estratégia da campanha',
  content: 'Conteúdo e pauta',
  proposal: 'Calendário aprovado',
  publication: 'Publicação confirmada',
  business_event: 'Evento comercial',
  manual_metric_reading: 'Leitura manual',
};
export interface ExportCandidate {
  entityKind: ExportKind;
  entityId: string;
  entityVersion: number;
  entityHash: string;
  previewHash: string;
  title: string;
  targetPath: string;
  baseSource: SourceRef | null;
  affectedEntities: { kind: string; id: string; label: string }[];
  snapshot: Record<string, unknown>;
  evidence: string[];
  instructions: string[];
  existingChangeId: string | null;
}
/** Prepared text is immutable; incorporation only records a successful later import. */
export interface ExportChange extends RecordBase {
  entityKind: ExportKind;
  entityId: string;
  entityVersion: number;
  entityHash: string;
  title: string;
  targetPath: string;
  baseSource: SourceRef | null;
  affectedEntities: ExportCandidate['affectedEntities'];
  snapshot: Record<string, unknown>;
  evidence: string[];
  instructions: string[];
  markdown: string;
  markdownHash: string;
  diff: string;
  preparedBy: string;
  status: 'pendente' | 'incorporada';
  incorporation: { source: SourceRef; syncId: string; checkedAt: string } | null;
}
export type ExportCheckResult =
  | 'aguardando'
  | 'fonte_ausente'
  | 'base_alterada'
  | 'texto_divergente'
  | 'calendario_divergente'
  | 'incorporada';
export interface ExportCheck extends RecordBase {
  exportChangeId: string;
  syncId: string;
  result: ExportCheckResult;
  observedSource: SourceRef | null;
  message: string;
}
export interface ExportWorkspaceData {
  candidates: ExportCandidate[];
  changes: (ExportChange & { entityChanged: boolean; latestCheck: ExportCheck | null })[];
  checks: ExportCheck[];
}
